/**
 * A number to `digits` places, never "-0.00".
 *
 * A component that is zero comes out of the solver as −1e-15 as often as +0,
 * and `toFixed` keeps the sign of whatever it rounded — so a rope straight up
 * read "-0.00" in its x column, which reads as a direction where there is none.
 */
export function fixed(n: number, digits: number): string {
    const s = n.toFixed(digits);
    return Number(s) === 0 ? (0).toFixed(digits) : s;
}

/**
 * A mass as a reader writes one: "5 kg", not "5.0 kg" — a whole number of
 * kilograms is written whole, and anything else to one place ("2.5 kg").
 */
export function kg(m: number): string {
    const whole = Math.round(m);
    return `${Math.abs(m - whole) < 1e-9 ? whole : fixed(m, 1)} kg`;
}
